import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Loading } from '../loading';

export const OEmbed = ({ url }) => {
  const [html, setHtml] = useState();
  const [script, setScript] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const unmounted = useRef(false);
  useEffect(
    () => () => {
      unmounted.current = true;
    },
    [],
  );

  useEffect(() => {
    if (url) {
      setScript(null);
      setHtml(null);
      setLoading(true);
      fetch(url)
        .then((response) => response.json())
        .then(({ html }) => {
          if (!unmounted.current) {
            setHtml(html);
            if (html) {
              const match = html.match(/<script[^>]+src=(['"])(.*?)\1/i);
              setScript(match && match[2]);
            }
          }
        })
        .catch((e) => (!unmounted.current ? setError(e) : null))
        .finally(() => (!unmounted.current ? setLoading(false) : null));
    }
  }, [url]);
  return (
    <>
      {script && (
        <Helmet>
          <script async src={script} />
        </Helmet>
      )}
      {loading && <Loading />}
      {error && <pre>{error.toString()}</pre>}
      {html && (
        <div
          style={{
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </>
  );
};
